module.exports = __webpack_public_path__ + "static/media/download-icon.627a9b6c.svg";